module.exports = __webpack_public_path__ + "img/quest_icon_0076_special5.ce46df7c.png";